module.exports = __webpack_public_path__ + "static/media/Profile.bc254664.svg";